import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownClockProps {
  size?: 'md' | 'lg';
  align?: 'left' | 'center';
}
const START_SECONDS = 14 * 60 + 59;
export function CountdownClock({
  size = 'md',
  align = 'left'
}: CountdownClockProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(START_SECONDS);
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  return <div className={`flex items-stretch gap-2 sm:gap-3 ${align === 'center' ? 'justify-center' : 'justify-center sm:justify-start'}`} role="timer" aria-label={`${hours} hours ${minutes} minutes ${seconds} seconds remaining`} data-id="element-74" data-mp="1x1179c6f2nor">
      {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-75" data-mp="3dfsqozll4klx" data-mpi={index}>
          {index > 0 ? <span className="self-center font-display text-2xl text-terracotta/40" aria-hidden="true" data-id="element-76" data-mp="3ddg76i06i26r">
              :
            </span> : null}
          <div className={`rounded-lg border border-terracotta/20 bg-terracotta-soft text-center ${size === 'lg' ? 'px-4 py-3 sm:px-7 sm:py-4' : 'px-3.5 py-2.5 sm:px-5'}`} data-id="element-77" data-mp="nqiv0igvu2dc">
            <span className={`block font-display font-semibold leading-none tabular-nums text-terracotta-dark ${size === 'lg' ? 'text-4xl sm:text-5xl' : 'text-2xl sm:text-3xl'}`} data-id="element-78" data-mp="sker1fdl5f5v">
              {unit.value}
            </span>
            <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.16em] text-muted" data-id="element-79" data-mp="duz5qewtq1xk">
              {unit.label}
            </span>
          </div>
        </React.Fragment>)}
    </div>;
}